module.exports = "/assets/data/0d77e54c5ed7f02c478377a0513ec11c-KW16.data.json";